// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/companion/components/records/CompanionRecords.module.css';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';

export function CompanionRecordsSkeleton() {
	const {i18n} = useLingui();
	return (
		<div
			className={styles.skeleton}
			role="status"
			aria-label={i18n._(msg({message: 'Loading…'}))}
			data-flx="companion.records.companion-records-skeleton.skeleton"
		>
			{[0, 1, 2].map((row) => (
				<div
					className={styles.skeletonRow}
					key={row}
					aria-hidden
					data-flx="companion.records.companion-records-skeleton.skeleton-row"
				>
					<span data-flx="companion.records.companion-records-skeleton.span" />
					<span data-flx="companion.records.companion-records-skeleton.span--2" />
				</div>
			))}
		</div>
	);
}
